import React, { useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { ReactComponent as CloudIcon } from "assets/img/svg/CloudArrow.svg";
import { ReactComponent as PdfIcon } from "assets/img/svg/pdfIcon.svg";
import { ReactComponent as UserProfileIcon } from "assets/img/svg/bankDocument.svg";
import { ReactComponent as PencilIcon } from "assets/img/svg/Edit2.svg";
import { RiEdit2Fill } from "react-icons/ri";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper.jsx";

import AButton from "../../../../common/form-fields-mui/AButton";
import ALoader from "../../../../common/a-loader";
import {
  failureToast,
  successToast,
} from "../../../../common/utils/methods/toasterFunctions/function";
import "../style.scss";
import { putpost, uploadpost } from "../../../../../../../services/utils";
import { endpoint } from "../../../../common/constant";
import { getUniqueKey } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { getDownloadFileUrl } from "./helper";
import { MdOutlineFileUpload } from "react-icons/md";
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadIcon.svg";

const UserPlaceHolder = () => {
  return (
    <div className="image-placeholder">
      <UserProfileIcon />
    </div>
  );
};

const UploadPhotoPlaceHolder = ({
  maxAllowedFileSize,
  supportedFileTypes,
  handleChange,
  disableUpload,
  file = null,
  loading,
  saveHandler,
  additionalUI,
  uploadedFiles,
  setOpen,
}) => {
  return (
    <div className="d-flex flex-column">
      <span className="mb-4" style={{ fontSize: "12px" }}>
        Max file size {maxAllowedFileSize} MB
      </span>
      {loading && <ALoader />}
      {file ? (
        <div className="ellipsis-text-container">
          <div className="text-center">
            <PdfIcon />
          </div>
          <div className="mb-4 mt-2 sub-heading ellipsis-text-container">
            {file?.name}
          </div>
          <div className="mb-2">
            <AButton
              className="button_remove_left_margin"
              updatedStyle={{ width: "100%" }}
              variant="primary_filled"
              onClick={() => {
                saveHandler(uploadedFiles);
                setOpen(false);
              }}
            >
              Save
            </AButton>
          </div>
          <div className="button-container">
            <label htmlFor="profilePhoto">
              <input
                id="profilePhoto"
                type="file"
                style={{ display: "none" }}
                onChange={handleChange}
              />
              <span
                className="upload-btn"
                style={{
                  border: "2px solid rgb(0, 176, 245)",
                  color: "rgb(0, 176, 245)",
                  backgroundColor: "unset",
                }}
              >
                Update
              </span>
            </label>
            <AButton
              updatedStyle={{ height: "41px" }}
              onClick={() => getDownloadFileUrl(file?.key)}
              variant="outline"
            >
              Download
            </AButton>
          </div>
          {additionalUI}
        </div>
      ) : (
        <div>
          <UserPlaceHolder />
          <div className="mb-4 mt-2 sub-heading">
            File supported:{" "}
            {supportedFileTypes.map((item) => `.${item}`).join(", ")}
          </div>

          <div>
            <label className="w-100" htmlFor="profilePhoto">
              <input
                id="profilePhoto"
                type="file"
                style={{ display: "none" }}
                onChange={handleChange}
              />
              <span className="upload-btn">
                Upload file <CloudIcon className="ml-2" />
              </span>
            </label>
          </div>
          {additionalUI}
        </div>
      )}
    </div>
  );
};

const UploadAttachments = ({
  disableUpload = false,
  form = [],
  setFormHandler = () => {},
  serviceName = "STOCK_BRANCH",
  supportedFileTypes = [
    "png",
    "jpeg",
    "jpg",
    "pdf",
    "docx",
    "xlsx",
    "xls",
    "xlsb",
    "csv",
  ],
  maxAllowedFileSize = 2,
  uploadButtonProps = {},
  uploadFileHeader = "Upload supporting document",
  disabledBtn = false,
  customUploadButton,
  additionalUI,
  saveCallback = () => {},
  type = "",
  uploadedFiles,
  setUploadedFiles,
}) => {
  console.log(form, "form");
  // const [uploadedFiles, setUploadedFiles] = useState(form || []);
  const [selectedFileIndex, setSelectedFileIndex] = useState(null);
  const [fileToEdit, setFileToEdit] = useState(null);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const maxFileSize = maxAllowedFileSize * 1024 * 1024;

  const dataToServer = {
    bulk: false,
    fileName: null,
    docType: "pdf",
    keyValue: `consession_${getUniqueKey()}`,
    serviceName,
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file.size > maxFileSize) {
      failureToast(`File must be under ${maxAllowedFileSize} MB`);
      return;
    }

    const fileType = file?.name?.split(".")?.pop();
    if (!supportedFileTypes.includes(fileType)) {
      failureToast(
        `Only ${supportedFileTypes
          .map((ft) => `.${ft}`)
          .join(", ")} files are allowed!`
      );
      return;
    }

    getFilePath(file.name, file, fileType);
  };

  const getFilePath = (name, file, fileType) => {
    setLoading(true);
    const formData = { ...dataToServer, fileName: name, docType: fileType };

    putpost(
      endpoint.fetchS3Url.getUrl,
      (data) => {
        if (data.code === 200 && data.data) {
          saveDataToStorage(data.data, file, name);
        }
      },
      (data) => {
        failureToast(data["message"]);
        setLoading(false);
      },
      formData,
      "post"
    );
  };

  const saveDataToStorage = (res, file, name) => {
    const formData = new FormData();
    formData.append("File", file);

    uploadpost(
      res.storage,
      () => {
        const newFile = { ...res, name };

        if (selectedFileIndex !== null) {
          const updatedFiles = [...uploadedFiles];
          updatedFiles[selectedFileIndex] = newFile;
          setUploadedFiles(updatedFiles);
          saveCallback(newFile, selectedFileIndex);
        } else {
          setUploadedFiles([...uploadedFiles, newFile]);
          saveCallback(newFile, uploadedFiles.length);
          setFileToEdit(newFile);
        }

        successToast("File uploaded successfully");
        setLoading(false);
        //   setOpen(false);
      },
      () => {
        failureToast("Upload failed. Please try again.");
        setLoading(false);
      },
      file,
      file?.type,
      file?.name
    );
  };

  const openEditModal = (index) => {
    setSelectedFileIndex(index);
    setFileToEdit(uploadedFiles[index]);
    setOpen(true);
  };

  const removeFile = (index) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
  };

  return (
    <>
      {uploadedFiles.map((file, index) => (
        <div key={index} className="file-exist-container mb-2">
          <PdfIcon className="pdf-icon flex-shrink-0" />
          <span className="ellipsis-text-container">{file?.name}</span>
          {!disableUpload && (
            <RiEdit2Fill
              size={22}
              className="flex-shrink-0 cursor color-primary"
              onClick={() => openEditModal(index)}
            />
          )}
          <DownloadIcon
            className="cursor"
            onClick={() => getDownloadFileUrl(file?.key)}
          />
        </div>
      ))}

      {!disableUpload &&
        (customUploadButton ? (
          customUploadButton(() => {
            setSelectedFileIndex(null);
            setFileToEdit(null);
            setOpen(true);
          })
        ) : (
          <AButton
            variant="outline"
            updatedStyle={{ minWidth: "200px" }}
            onClick={() => {
              setSelectedFileIndex(null);
              setFileToEdit(null);
              setOpen(true);
            }}
            disabled={disabledBtn}
            className="mb-3"
            {...uploadButtonProps}
          >
            <MdOutlineFileUpload className="mr-1" size="24px" />
            <span className="ml-2">Upload</span>
          </AButton>
        ))}

      <Modal size="md" isOpen={open}>
        <ModalBody>
          <div className="d-flex justify-content-between align-items-center">
            <span className="heading-3 color-dark">{uploadFileHeader}</span>
            <IconButtonWrapper onClick={() => setOpen(false)}>
              <CrossIcon />
            </IconButtonWrapper>
          </div>
          <UploadPhotoPlaceHolder
            maxAllowedFileSize={maxAllowedFileSize}
            supportedFileTypes={supportedFileTypes}
            handleChange={handleChange}
            file={fileToEdit}
            loading={loading}
            additionalUI={additionalUI}
            saveHandler={setFormHandler}
            uploadedFiles={uploadedFiles}
            setOpen={setOpen}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default UploadAttachments;
